import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CalendarEvent, eventify } from 'calendar-link';

import { CalendarProviders } from '@libs/src/calendar-links/calendar-providers.type';

@Component({
  selector: 'app-add-to-calendar-dialog',
  templateUrl: './add-to-calendar-dialog.component.html',
})
export class AddToCalendarDialogComponent implements OnInit {
  calculatedDate: { endDate: Date; startDate: Date };

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      calendarEvent: CalendarEvent;
      supportedProviders: CalendarProviders;
    },
  ) {}

  ngOnInit() {
    this.calculatedDate = this.calculateDates(this.data.calendarEvent);
  }

  calculateDates(calendarEvent: CalendarEvent) {
    const { endUtc } = eventify(calendarEvent);
    return {
      endDate: new Date(endUtc.toISOString()),
      startDate: new Date(calendarEvent.start),
    };
  }
}
